import * as React from 'react';
import  { withStyles, WithStyles } from '@mui/styles';
import AppView from "~common/components/app-view/index"

const styles = {
}

interface Props extends React.HTMLProps<HTMLDivElement>{
  history: any
};

type State = {
  drawerOpen?:any;
};

class MaintenanceModeView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {}; 
  }

  UNSAFE_componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){
    this.setState({drawerOpen: false})
  }


  render () {

    // const { classes } = this.props

    return (
      <AppView history={this.props.history}>
        <div>The portal is currently undergoing scheduled maintenance.</div>
      </AppView>
    );
  }
}

export default withStyles(styles)(MaintenanceModeView);

